var url="https://api.qljkb.cn/" //线上
// var url="http://localhost:8082/" //本地
export default{
	 url
}